import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import LaborCategoriesPage from "@/pages/admin/LaborCategoriesPage";

export const Route = createFileRoute("/_admin/admin/labor-categories")({
  head: () => pageHead("Admin · Labor Categories", "AKIVA admin · labor categories portal.", "/admin/labor-categories", true),
  component: LaborCategoriesPage,
});
